import { useTheme } from "@mui/material";
import React from "react";
import { usePostSegmentStatisticsTotalCustomersQuery } from "@tiny/api";
import { useRefreshRegister } from "@tiny/components/src/RefreshProvider";
import { createSegmentsChartData } from "./SubscribersBySource.helpers";

export function useSubscribersBySourceStats() {
  const theme = useTheme();

  const { data, refetch, isLoading } =
    usePostSegmentStatisticsTotalCustomersQuery({
      integrationLimit: 2,
    });

  useRefreshRegister(async () => {
    await refetch();
  });

  const chartData = React.useMemo(() => {
    return createSegmentsChartData(data?.segments, theme);
  }, [data, theme]);

  return {
    chartData,
    isLoading,
  };
}
